"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogosContainer = exports.NetworkAffiliationsListItem = exports.NetworkAffiliationsList = exports.NetworkAffiliationsFlexContainer = exports.NetworkAffiliationsHeader = exports.NetworkAffiliationsSection = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const constants_1 = require("../../lib/constants");
const dot_spacer_styles_1 = require("../../lib/styles/dot-spacer.styles");
exports.NetworkAffiliationsSection = styled_1.default.div `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
exports.NetworkAffiliationsHeader = styled_1.default.strong `
  display: block;
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
`;
exports.NetworkAffiliationsFlexContainer = styled_1.default.div `
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
`;
exports.NetworkAffiliationsList = styled_1.default.ul `
  padding: 0;
  margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
`;
exports.NetworkAffiliationsListItem = styled_1.default.li `
  list-style: none;
  margin: 0 ${(0, ui_theme_1.fromTheme)('spacing_small')} 0 0;
  margin-bottom: ${(props) => props.hasLogos ? (0, ui_theme_1.fromTheme)('spacing_small') : '0'};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  display: inline-block;

  & + li:before {
    ${(props) => (0, dot_spacer_styles_1.dotSpacer)({ marginRight: (0, ui_theme_1.fromTheme)('spacing_small')(props) })}
  }

  @media screen and (max-width: ${constants_1.BREAKPOINTS.small}px) {
    display: block;
    & + li:before {
      display: none;
    }
  }
`;
exports.LogosContainer = styled_1.default.div `
  margin-top: -${(0, ui_theme_1.fromTheme)('spacing_small')};

  @media screen and (max-width: ${constants_1.BREAKPOINTS.small}px) {
    margin-top: 0;
  }
`;
//# sourceMappingURL=network-affiliations-styles.js.map